import React, { FC } from "react"

export const NoData: FC<{}> = () => <span className="text-rhino-400">-</span>
